import React, { useState } from 'react';
import { TimePicker as AntdTimePicker } from 'antd';
import dayjs from 'dayjs';
import AreaPicker from './AreaPicker';
import { formatTimeOnly } from './Utilitiy';

const TimePicker = (props) => {
  const {
    token,
    starttime,
    endtime,
    handleTimeChange,
    selectedBookedItem,
    removeBookedItem,
    setShowTimePicker,
  } = props;

  const [selectedArea, setSelectedArea] = useState(selectedBookedItem?.areaName || '');
  const [selectedStartDate, setSelectedStartDate] = useState(starttime);
  const [selectedEndDate, setSelectedEndDate] = useState(endtime);

  const makeCellEmpty = () => {
    removeBookedItem();
    setShowTimePicker(false);
  };

  const handleSave = () => {
    handleTimeChange(null, selectedStartDate, 'endtime', selectedArea, selectedEndDate);
    setShowTimePicker(false);
  };

  const onStartTimeChange = (time) => {
    if (time) {
      const updated = new Date(selectedStartDate);
      updated.setHours(time.hour());
      updated.setMinutes(time.minute());
      updated.setSeconds(0);
      updated.setMilliseconds(0);
      setSelectedStartDate(updated);
    }
  };

  const onEndTimeChange = (time) => {
    if (time) {
      const updated = new Date(selectedEndDate);
      updated.setHours(time.hour());
      updated.setMinutes(time.minute());
      updated.setSeconds(0);
      updated.setMilliseconds(0);
      setSelectedEndDate(updated);
    }
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalView}>
        <AreaPicker
          selectedArea={selectedArea}
          setSelectedArea={setSelectedArea}
          token={token}
        />

        <div style={styles.rowItem}>
          <label style={styles.modalText}>Start time:</label>
          <AntdTimePicker
            value={dayjs(selectedStartDate)}
            onChange={onStartTimeChange}
            format="HH:mm"
            style={styles.timeInput}
          />
        </div>

        <div style={styles.rowItem}>
          <label style={styles.modalText}>End time:</label>
          <AntdTimePicker
            value={dayjs(selectedEndDate)}
            onChange={onEndTimeChange}
            format="HH:mm"
            style={styles.timeInput}
          />
        </div>

        <div style={styles.buttonContainer}>
          <button onClick={handleSave} style={styles.button}>Save</button>
          <button onClick={makeCellEmpty} style={styles.button}>Remove</button>
          <button onClick={() => setShowTimePicker(false)} style={styles.button}>Close</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalView: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 20,
    minWidth: '300px',
    maxWidth: '90%',
    boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
  },
  modalText: {
    fontSize: 14,
    color: '#333',
    marginRight: 10,
    minWidth: 80,
  },
  rowItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  timeInput: {
    width: 120,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 20,
  },
  button: {
    padding: '8px 12px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
  },
};

export default TimePicker;
